import { Segmented } from 'antd'
import React from 'react'

const ANTDSegmented = ({ onChange, value, options, ...rest }) => {
  return (
    <Segmented value={value} onChange={onChange} options={options} {...rest} />
  )
}

export default ANTDSegmented
